<router-outlet />

<footer class="app-footer">
  powered by
  <span class="app-footer-brand"
    >Gym<span class="app-footer-brand-accent">Scan</span></span
  >
</footer>
